import React, { FC, SVGProps } from 'react'
import styled from 'styled-components'
import { FlexColumn, FlexRow } from '../../FlexboxReusables/FlexItems'
import { Typography } from 'antd'

interface FeatherIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}

interface ExamInstructionsBlockProps {
  Icon: FC<FeatherIconProps>
  iconColor?: string
  heading: string
  text: string | number
  centered?: boolean
}

const ExamInstructionsBlock: React.FC<ExamInstructionsBlockProps> = ({ Icon, iconColor, heading, text, centered }) => {
  return (
    <ExamInfoRow>
      <FlexColumn>
        <ExamInfoTextRow centered={centered}>
          <Icon size={18} style={{ marginRight: '0.5em', color: iconColor || 'green' }} />
          <ExamInfoHeading>{heading}</ExamInfoHeading>
          <ExamInfoText style={{marginLeft: '0.5em'}}>{text}</ExamInfoText>
        </ExamInfoTextRow>
      </FlexColumn>
    </ExamInfoRow>
  )
}

export default ExamInstructionsBlock

const ExamInfoHeading = styled(Typography.Text)`
  font-size: 1em;
  color: black;
`

const ExamInfoTextRow = styled(FlexRow)<{ centered?: boolean }>`
  display: flex;
  ${props => props.centered ? 'justify-content: center;' : 'justify-content: flex-start;'}
  ${props => props.centered ? '' : 'margin-left: 30%;'}
`

const ExamInfoText = styled(Typography.Text)`
  font-size: 1.2em;
  color: black;
  font-weight: bold;
`

const ExamInfoRow = styled(FlexRow)`
  margin: 0.4em 0;
`